import styled from 'styled-components';

export const DoohInventoryVolumetryLoadingStyled = styled.div`
  padding: 26px 20px;
  background: ${props => props.theme.uiColors.background01};
`;

export const DoohInventoryVolumetryStyled = styled.div`
  display: flex;
  justify-content: center;
  padding: 28px 0;
  background: ${props => props.theme.uiColors.background01};

  .doohInventoryVolumetry {

    &__metric {
      padding: 0 8px;

      &Value {
        margin-right: 8px;
        color: ${props => props.theme.uiColors.textTitle};
        font-family: ${props => props.theme.fontSemiBold};
        font-size: ${props => props.theme.fontSizeL};
      }

      &Name {
        font-size: ${props => props.theme.fontSizeS};
        font-family: ${props => props.theme.fontRegular};
        color: ${props => props.theme.uiColors.textBodySoft};
      }
    }

  }
`;
